export const SET_4DGAME_SUBTYPE = "SET_4DGAME_SUBTYPE"
export const SET_4DGAME_SUB_CHILDTYPE = "SET_4DGAME_SUB_CHILDTYPE"